import { render, staticRenderFns } from "./VisualizarTermoDIalog.vue?vue&type=template&id=17de0e05"
import script from "./VisualizarTermoDIalog.vue?vue&type=script&lang=js"
export * from "./VisualizarTermoDIalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports